// ── registro de temas + relógio por horário local ─────────────────────────────
// Ver docs/design/theme-time.md. Três temas (dawn/sunset/dusk) trocados pela hora
// local do jogador quando a preferência é "auto". A troca só seta
// html[data-theme="<id>"] (o CSS de cada tema já vem escopado por esse atributo —
// client/src/theme/all.css) e emite `warspace:theme` na window para o Pixi invalidar o
// cache de texturas.
//   import {applyTheme,startThemeClock,currentTheme} from "./theme/index.js";
//   import "./theme/all.css";
//   applyTheme(resolveThemeId(prefs.theme));           // antes do primeiro paint
//   const stop=startThemeClock(()=>prefs.theme,(id,theme)=>renderer.invalidateTextures());
import dawn from "./dawn/index.js";
import sunset from "./sunset/index.js";
import dusk from "./dusk/index.js";
import {TEMA_FIXO} from "../portal/flags.js";

export const THEMES={dawn,sunset,dusk};
export const DEFAULT_THEME="dawn";
// horas locais [from,to); "to" acima de 24 atravessa a meia-noite (dusk: 20:00 → 04:59)
export const SCHEDULE=[{id:"dawn",from:5,to:16},{id:"sunset",from:16,to:20},{id:"dusk",from:20,to:29}];
export const THEME_PREFS=["auto","dawn","sunset","dusk"];

// 'auto' → pela hora de `when` (Date, ou hora 0..24 do relógio do espaço da rodada); id conhecido → ele mesmo
export function resolveThemeId(pref="auto",when=new Date()){
  if(pref&&pref!=="auto"&&THEMES[pref])return pref;
  // pacote com tema fixo (portal/flags.js): o "auto" deixa de olhar o relógio — do jogador E da rodada
  if(TEMA_FIXO&&THEMES[TEMA_FIXO])return TEMA_FIXO;
  const h=typeof when==="number"?((when%24)+24)%24:when.getHours()+when.getMinutes()/60;
  for(const s of SCHEDULE){if(h>=s.from&&h<s.to)return s.id;if(s.to>24&&h+24>=s.from&&h+24<s.to)return s.id;}
  return DEFAULT_THEME;}

let current=null;
// aplica o tema no <html> (data-theme); as variáveis CSS vêm de tokens.css, nada é setado em style.
// Emite window 'warspace:theme' {detail:{id,theme,prev}} só quando o tema muda de fato.
// `fade`: a troca é imediata; quem faz o fade é SÓ o céu, dentro do Pixi (renderer/layers/Background.js), que ao
// receber o `warspace:theme` guarda o céu velho num sprite por cima e o dissolve em ROUND.FADE_MS. Nada de overlay
// cobrindo a tela: HUD, telas e o jogo continuam visíveis durante a virada.
export function applyTheme(id,{fade=false}={}){   // `fade` continua na assinatura (os chamadores pedem a troca suave), mas quem faz o fade é o céu
  return swapTheme(THEMES[id]||THEMES[DEFAULT_THEME]);}
function swapTheme(th){
  const prev=current,root=typeof document!=="undefined"?document.documentElement:null;
  const same=prev&&prev.id===th.id&&(!root||root.dataset.theme===th.id);
  current=th;
  if(root)root.dataset.theme=th.id;
  if(!same&&typeof window!=="undefined")window.dispatchEvent(new CustomEvent("warspace:theme",{detail:{id:th.id,theme:th,prev:prev?prev.id:null}}));
  return th;}

export function currentTheme(){return current||THEMES[resolveThemeId("auto")];}
/** Tema que vale agora para quem decide trocas. */
export function currentThemeId(){return current?current.id:null;}

// Reavalia a cada `interval` e na volta do foco (visibilitychange → visible); getPref() devolve 'auto'|id.
// getHour() (opcional) devolve a hora do relógio do espaço da rodada (0..24) ou null fora da partida — dentro
// de uma partida o céu segue a rodada (10 min = um dia), então a checagem é de 1 s; fora dela, a hora local.
// Chama applyTheme quando muda e onChange(id,theme). A 1ª aplicação é seca; as seguintes passam pelo fade.
// Devolve stop(); stop.check() força uma reavaliação.
export function startThemeClock(getPref=()=>"auto",onChange=null,{interval=1000,getHour=null}={}){
  const check=()=>{const h=getHour?getHour():null,id=resolveThemeId(getPref(),h==null?new Date():h),cur=currentThemeId();
    if(cur!==id||(typeof document!=="undefined"&&document.documentElement.dataset.theme!==id)){applyTheme(id,{fade:!!current});if(onChange)onChange(id,current);}
    return id;};
  check();
  const timer=setInterval(check,interval);
  const onVis=()=>{if(document.visibilityState==="visible")check();};
  if(typeof document!=="undefined")document.addEventListener("visibilitychange",onVis);
  const stop=()=>{clearInterval(timer);if(typeof document!=="undefined")document.removeEventListener("visibilitychange",onVis);};
  stop.check=check;return stop;}
